export default __webpack_public_path__ + "static/media/uploadModelArrow.d2fce0ad.svg";